import { EventArgs } from 'react-ga'

export enum AnalyticsEvent {
  RescheduleOpen,
  RescheduleRequest,
  RescheduleRequestSuccess,
  RescheduleRequestFail,
  CallCourier,
  LogoClick,
  DownloadButton,
  ApplicationOpened,
  KeepCurrentSchedule,
  DeliveryRated,
}

export enum PageTypes {
  Tracking = 'tracking',
  Rating = 'rating',
}

export const AnalyticsEventMap: {[key in AnalyticsEvent]: AnalyticsEventData} = {
  [AnalyticsEvent.RescheduleOpen]: {
    category: 'Reschedule',
    action: 'Reschedule Open',
  },
  [AnalyticsEvent.RescheduleRequest]: {
    category: 'Reschedule',
    action: 'Reschedule Request',
  },
  [AnalyticsEvent.RescheduleRequestSuccess]: {
    category: 'Reschedule',
    action: 'Reschedule Success',
    nonInteraction: true,
  },
  [AnalyticsEvent.RescheduleRequestFail]: {
    category: 'Reschedule',
    action: 'Reschedule Fail',
    nonInteraction: true,
  },
  [AnalyticsEvent.CallCourier]: {
    category: 'Courier',
    action: 'Call Courier',
  },
  [AnalyticsEvent.LogoClick]: {
    category: 'Logo',
    action: 'Logo Click',
  },
  [AnalyticsEvent.DownloadButton]: {
    category: 'DownloadButton',
    action: 'DownloadButton Click',
  },
  [AnalyticsEvent.ApplicationOpened]: {
    category: 'Application',
    action: 'Tracker Open',
  },
  [AnalyticsEvent.KeepCurrentSchedule]: {
    category: 'Reschedule',
    action: 'Keep Current Schedule',
  },
  [AnalyticsEvent.DeliveryRated]: {
    category: 'Application',
    action: 'Delivery Rated',
  },
}

export const MixpanelEventMap: {[key in AnalyticsEvent]: string } = {
  [AnalyticsEvent.RescheduleOpen]: 'web_tracker|reschedule|page_clicked',
  [AnalyticsEvent.RescheduleRequest]: 'web_tracker|reschedule|reschedule_requested',
  [AnalyticsEvent.RescheduleRequestSuccess]: 'web_tracker|reschedule|reschedule_success',
  [AnalyticsEvent.RescheduleRequestFail]: 'web_tracker|reschedule|reschedule_fail',
  [AnalyticsEvent.CallCourier]: 'web_tracker|call_courier|clicked',
  [AnalyticsEvent.LogoClick]: 'web_tracker|logo_clicked',
  [AnalyticsEvent.DownloadButton]: 'web_tracker|download _app_clicked',
  [AnalyticsEvent.ApplicationOpened]: 'web_tracker|page_opened',
  [AnalyticsEvent.KeepCurrentSchedule]: 'web_tracker|reschedule|keep_current_schedule_selected',
  [AnalyticsEvent.DeliveryRated]: 'web_tracker|rating|delivery_rated',
}

export const MixpanelPropertiesMap: { [key: string]: string } = {
  dimension1: 'company_name',
  dimension2: 'env',
  dimension3: 'delivery_uuid',
  dimension4: 'delivery_status',
}

export interface AnalyticsEventData extends EventArgs {}
